import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { X } from 'lucide-react';
export function FailedSolutions() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const solutions = ['Los baños de espuma y las velas son parches superficiales que no reparan un sistema nervioso colapsado.', 'Intentar dormir más no funciona porque tu cerebro se despierta a las 3 AM repasando la lista de pendientes.', 'Las vacaciones solo posponen el colapso; el estrés regresa con más fuerza apenas abres la maleta al volver.', 'El café te da una energía nerviosa que termina en una caída estrepitosa y más irritabilidad por la tarde.'];
  return <section className="py-20 px-4 bg-sage" data-id="element-1">
      <div ref={ref} className={`max-w-4xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-2">
        <h2 className="text-3xl md:text-4xl font-serif text-teal text-center mb-12" data-id="element-3">
          Por qué lo que has intentado no funciona
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4">
          {solutions.map((solution, index) => <div key={index} className="bg-white p-6 rounded-2xl shadow-sm flex items-start gap-4" data-id="element-5">
              <div className="bg-red-50 p-2 rounded-full shrink-0 mt-1" data-id="element-6">
                <X className="w-5 h-5 text-red-400" data-id="element-7" />
              </div>
              <p className="text-charcoal leading-relaxed" data-id="element-8">{solution}</p>
            </div>)}
        </div>
      </div>
    </section>;
}